import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://gengplay.com/la3btnaAPI/APIs/`
})

